import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List, Button, Icon, Typography, message } from 'antd';
import PricingSummary from '@components/PricingSummary';

import PropertyActions, { PropertySelectors } from '@redux/PropertyRedux';
import API from '@utils/api';
import { getErrors } from '@utils/error';

const { Title, Text } = Typography;

function PropertySettingsTable(props) {
  const { propertySettings, propertyId, updatePropertySettings } = props;
  const [isSubmitting, setSubmitting] = useState(false);

  const toggleActivate = async propertySettingId => {
    setSubmitting(true);
    try {
      await API.activatePropertySetting(propertyId, propertySettingId);

      const newSettings = propertySettings.map(item => {
        const { propertySettingsID: itemId } = item;
        return {
          ...item,
          isActive: itemId === propertySettingId
        };
      });

      updatePropertySettings(newSettings);
    } catch (err) {
      const error = getErrors(err);
      message.error(error.message);
    }
    setSubmitting(false);
  };

  const renderPropertySetting = setting => {
    const { propertySettingsID: propertySettingId, notes, isActive } = setting;
    return (
      <List.Item
        key={propertySettingId}
        actions={[
          <Button
            disabled={isSubmitting || isActive}
            type="primary"
            key="activate"
            onClick={() => toggleActivate(propertySettingId)}
          >
            <Icon type={isActive ? 'stop' : 'check'} />
            Activate
          </Button>
        ]}
      >
        <div>
          <Title disabled={!isActive} level={4}>
            {isActive ? 'Active Setting' : 'Inactive'}
          </Title>
          <PricingSummary pricingData={setting} disabled={!isActive} />
          <div>
            <Text disabled={!isActive}>{notes}</Text>
          </div>
        </div>
      </List.Item>
    );
  };

  return (
    <List
      itemLayout="horizontal"
      size="large"
      dataSource={propertySettings}
      renderItem={renderPropertySetting}
    />
  );
}

PropertySettingsTable.propTypes = {
  propertySettings: PropTypes.array,
  propertyId: PropTypes.any,
  updatePropertySettings: PropTypes.func
};

const mapStateToProps = state => ({
  propertyId: PropertySelectors.selectPropertyId(state),
  propertySettings: PropertySelectors.selectAllSettings(state)
});

const mapDispatchToProps = dispatch => ({
  updatePropertySettings: data =>
    dispatch(PropertyActions.setPropertySettings(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertySettingsTable);
